// Libs
import React from 'react'
import PropTypes from 'prop-types'

// PropTypes
import {
  record as recordPropType,
  maybeFunction,
} from './propTypes'

// Styles
import {
  checkboxStyle,
} from './styles'

// Components
import checked from './Checked'
import unchecked from './Unchecked'

// Exports
export default function SelectionCheckbox ({record, onSelect, selected}) {
  if (typeof onSelect !== 'function') {
    return null
  }

  return (
    <div style={checkboxStyle} onClick={onSelect}>
      {selected ? checked : unchecked}
    </div>
  )
}

SelectionCheckbox.propTypes = {
  record: recordPropType,
  onSelect: maybeFunction,
  selected: PropTypes.bool.isRequired,
}
